import { BaseObject } from "../core/BaseObject";

export class ServiceTypeItem extends BaseObject {
	id: number;
	name: string;
}
